/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=2bb3470a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "../../assets/css/springWater_detail.css?vue&type=style&index=0&id=2bb3470a&scoped=true&lang=css&external"
import "./detail.vue?vue&type=style&index=1&id=2bb3470a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb3470a"]])

export default __exports__